<template>
  <div class="my-credit">
    <NavHeaderBar title="学分申请" leftArrow rightArrow />
    <div class="wrap">
      <van-tabs v-model="active" type="card" color="#1989fa">
        <van-tab title="未申请">
          <div class="inner">
            <template v-if="creditList.length > 0">
              <van-cell-group
                ><van-cell
                  v-for="item in creditList"
                  :key="item.creditType"
                  center
                >
                  <template #title>
                    <p class="custom-title">
                      {{ item.creditTypeName }} - {{ item.creditYear }}年度
                    </p>
                    <van-tag
                      plain
                      :type="item.source === 1 ? 'success' : 'warning'"
                      >{{ item.source | filterCreditSource }}</van-tag
                    >
                  </template>
                  <template #label>
                    <span style="margin-right: 15px"
                      >可申请：{{ item.amount }}分</span
                    >
                    <span>已获取：{{ item.totalAmount }}分</span>
                  </template>
                  <template #default>
                    <van-button
                      type="info"
                      size="mini"
                      style="padding: 10px"
                      :disabled="item.amount === 0"
                      @click="
                        handleOpenForm(
                          item.creditType,
                          item.amount,
                          item.source,
                          item.totalAmount
                        )
                      "
                      >申请学分</van-button
                    >
                  </template>
                </van-cell></van-cell-group
              >
            </template>
            <van-empty v-else description="暂无可申请学分" />
          </div>
        </van-tab>
        <van-tab title="已申请">
          <div class="inner">
            <template v-if="applyList.length > 0">
              <van-cell-group>
                <van-cell
                  v-for="item in applyList"
                  :key="item.id"
                  :label="`申请学分：${item.amount}分`"
                  center
                >
                  <template #title>
                    <span class="custom-title">{{ item.creditTypeName }} </span>
                    <van-tag :color="item.status | fiterColor">{{
                      item.status | filterCreditStatus
                    }}</van-tag>
                  </template>
                  <template #default>
                    <van-button
                      v-if="item.approvalOpinion && item.status === 3"
                      type="info"
                      size="mini"
                      plain
                      @click="
                        $dialog.alert({
                          message: item.approvalOpinion
                        })
                      "
                      >查看审核意见
                    </van-button>
                    <van-button
                      v-if="item.status === 4"
                      type="info"
                      size="mini"
                      plain
                      :disabled="!item.creditUrl"
                      @click="
                        $dialog.alert({
                          message: item.creditUrl
                        })
                      "
                      >{{
                        item.creditUrl ? "下载证书" : "暂无下载"
                      }}</van-button
                    >
                  </template>
                </van-cell>
              </van-cell-group>
            </template>
            <van-empty v-else description="暂无申请内容" />
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import apis from "@/config/apis";
export default {
  name: "MyCredit",
  data: () => ({
    active: 0,
    creditList: [],
    applyList: []
  }),
  watch: {
    active: {
      immediate: true,
      handler: function(active) {
        if (active === 0) {
          this.fetchgetCreditList();
        } else {
          this.fetchgetApplyCreditList();
        }
      }
    }
  },
  methods: {
    // 获取未申请学分列表
    async fetchgetCreditList() {
      try {
        const { data, success, msg } = await apis.credit.getCreditList();
        if (success === "ok") {
          this.creditList = data;
        } else {
          this.$toast(msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取申请列表
    async fetchgetApplyCreditList() {
      try {
        const { data, success, msg } = await apis.credit.getApplyCreditList();
        if (success === "ok") {
          this.applyList = data;
        } else {
          this.$toast(msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 下载证书
    handleClickDownload(url) {
      const domA = document.createElement("a");
      domA.href = url;
      domA.click();
    },
    // 前往申请
    handleOpenForm(id, amount, source, totalAmount) {
      // 判断该学分是否为免费学分，如果是则必须满10分才能申请
      if (source === 1) {
        // 直播获取
        if (totalAmount >= 10) {
          this.$router.push(
            "/applyCreditForm/" + id + "/" + amount + "/" + source
          );
        } else {
          this.$dialog.alert({
            title: "温馨提示",
            message: "您通过观看直播获取的学分不够10分，暂时无法申请。"
          });
        }
      } else {
        this.$router.push(
          "/applyCreditForm/" + id + "/" + amount + "/" + source
        );
      }
    }
  },
  filters: {
    filterCreditSource(val) {
      switch (val) {
        case 1:
          return "直播获取";
        case 2:
          return "VIP获取";
        case 3:
          return "线下购买";
        case 4:
          return "活动赠送";
      }
    },
    filterCreditStatus(val) {
      switch (val) {
        case 1:
          return "待审核";
        case 2:
          return "审核通过";
        case 3:
          return "审核不通过";
        case 4:
          return "学分已发放";
      }
    },
    fiterColor(val) {
      if (val === 1) {
        return "#108ee9";
      } else if (val === 2) {
        return "#87d068";
      } else if (val === 3) {
        return "#f50";
      } else if (val === 4) {
        return "#2db7f5";
      }
    }
  }
};
</script>

<style lang="scss">
.my-credit {
  padding-top: 46px;
  background-color: #f7f7f7;
  min-height: 100vh;
  box-sizing: border-box;
  .wrap {
    padding-top: 15px;
    .inner {
      padding: 10px 15px;
      .van-cell__value {
        flex: none;
      }
    }
  }
}
</style>
